import React from "react";
import classNames from "classnames";

export default function ({ className, onClick, children }) {
  return (
    <button
      className={classNames("gradient-btn", { [className]: !!className })}
      onClick={onClick}
      type="button"
    >
      <span>{children}</span>
    </button>
  );
}
